import React from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import { Line } from 'react-chartjs-2'

// ثبت ماژول‌های Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
)

const ChartPage = () => {
  // داده‌های نمودار اول
  const data1 = {
    labels: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00'],
    datasets: [
      {
        label: 'Variable 1',
        data: [100, 50, 150, 75, 100, 125, 150],
        borderColor: 'rgba(0,255,0,1)', // سبز
        backgroundColor: 'rgba(0,255,0,0.2)',
        pointBackgroundColor: 'rgba(0,255,0,1)',
        pointBorderColor: '#fff',
      },
      {
        label: 'Variable 2',
        data: [50, 100, 125, 150, 50, 75, 100],
        borderColor: 'rgba(0,0,0,1)', // سیاه
        backgroundColor: 'rgba(0,0,0,0.2)',
        pointBackgroundColor: 'rgba(0,0,0,1)',
        pointBorderColor: '#fff',
      },
    ],
  }

  // داده‌های نمودار دوم
  const data2 = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
    datasets: [
      {
        label: 'Sales 2024',
        data: [500, 600, 700, 800, 750, 850, 900],
        borderColor: 'rgba(54,162,235,1)', // آبی
        backgroundColor: 'rgba(54,162,235,0.2)',
        pointBackgroundColor: 'rgba(54,162,235,1)',
        pointBorderColor: '#fff',
      },
      {
        label: 'Sales 2023',
        data: [400, 450, 500, 600, 550, 700, 800],
        borderColor: 'rgba(255,99,132,1)', // قرمز
        backgroundColor: 'rgba(255,99,132,0.2)',
        pointBackgroundColor: 'rgba(255,99,132,1)',
        pointBorderColor: '#fff',
      },
    ],
  }

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        enabled: true,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Time/Month',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Values',
        },
        beginAtZero: true,
      },
    },
  }

  return (
    <div>
      <h2>Load Voltage's Chart</h2>
      <Line data={data1} options={options} />

      <h2 style={{ marginTop: '50px' }}>Monthly Sales Chart</h2>
      <Line data={data2} options={options} />
    </div>
  )
}

export default ChartPage
